module.exports = __webpack_public_path__ + "assets/img/maohao.9a5040e8.svg";